import React from 'react';
import { Card, Col, Row, Statistic, Table, Tag } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { epcService } from '@/services/epc.service';

type Props = { projectId?: string };

export const ProductivityPanel: React.FC<Props> = ({ projectId }) => {
  const q = useQuery({
    queryKey: ['cep-productivity', projectId],
    queryFn: () => epcService.getCepProductivity(projectId),
    enabled: !!projectId,
    staleTime: 15_000,
  });

  if (!projectId) return <Tag>Select a project for productivity KPIs</Tag>;

  const data = (q.data || {}) as any;
  const totals = data.totals || {};
  const byPackage = (data.by_package as any[]) || [];

  return (
    <div>
      <Tag color="geekblue" style={{ marginBottom: 12 }}>
        CEP Wave 5 — computed from manpower + package progress
      </Tag>
      <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Avg progress %" value={totals.avg_progress_pct ?? 0} precision={1} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Actual hours" value={totals.actual_hours ?? 0} precision={1} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic title="Headcount" value={totals.headcount ?? 0} />
          </Card>
        </Col>
        <Col xs={12} md={6}>
          <Card size="small">
            <Statistic
              title="Productivity index"
              value={totals.productivity_index ?? 0}
              precision={4}
              suffix="/h"
            />
          </Card>
        </Col>
      </Row>
      <Table
        size="small"
        rowKey={(r) => String(r.package_id)}
        loading={q.isLoading}
        dataSource={byPackage}
        columns={[
          { title: 'Package', dataIndex: 'package_number', width: 140 },
          { title: 'Status', dataIndex: 'status', width: 120 },
          { title: 'Progress %', dataIndex: 'progress_pct', width: 100 },
          { title: 'Planned h', dataIndex: 'planned_hours', width: 100 },
          { title: 'Actual h', dataIndex: 'actual_hours', width: 100 },
          { title: 'Index', dataIndex: 'productivity_index', width: 100 },
        ]}
      />
    </div>
  );
};

export default ProductivityPanel;
